import React, { useMemo } from 'react'
import { css, keyframes } from '@emotion/core'
import { Icon, IconProps } from '@chakra-ui/core'

const skeletonGlow = (colorStart, colorEnd) => keyframes`
  from {
    color: ${colorStart};
  }
  to {
    color: ${colorEnd};
  }
`

const getStyle = ({ colorStart, colorEnd, speed }) => css`
  box-shadow: none !important;
  opacity: 0.7;
  color: ${colorStart};
  cursor: default;
  animation: ${speed}s linear infinite alternate ${skeletonGlow(colorStart, colorEnd)};
  pointer-events: none;
  user-select: none;
`

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

const fadeInCss = duration => css`
  animation: ${fadeIn} ${duration}s;
`

export interface IconSkeletonProps extends IconProps {
  colorStart?: string
  colorEnd?: string
  isLoaded?: boolean
  fadeInDuration?: number
  speed?: number
}

export const IconSkeleton = ({
  colorStart = '#F8F8F8',
  colorEnd = '#DDD',
  isLoaded = false,
  fadeInDuration = 0.4,
  speed = 0.8,
  ...restProps
}: IconSkeletonProps) => {
  const fadeInStyle = useMemo(() => fadeInCss(fadeInDuration), [fadeInDuration])
  const skeletonStyle = useMemo(() => getStyle({ colorStart, colorEnd, speed }), [
    colorStart,
    colorEnd,
    speed,
  ])

  if (isLoaded) {
    return <Icon css={fadeInStyle} {...restProps} />
  }

  return <Icon css={skeletonStyle} {...restProps} />
}

export default IconSkeleton
